import * as React from "react";
const CloseIcon = (props: any) => (
  <svg
    width="current"
    height="current"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_1319_27170"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={24}
      height={24}
    >
      <rect width={24} height={24} fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1319_27170)">
      <path
        d="M12 12.9966L7.20216 17.7945C7.07122 17.9254 6.90663 17.9924 6.70838 17.9954C6.51016 17.9985 6.34254 17.9315 6.20553 17.7945C6.06851 17.6575 6 17.4914 6 17.2962C6 17.101 6.06851 16.9349 6.20553 16.7978L11.0034 12L6.20553 7.20216C6.07458 7.07122 6.00759 6.90663 6.00456 6.70838C6.00152 6.51016 6.06851 6.34254 6.20553 6.20553C6.34254 6.06851 6.50864 6 6.70384 6C6.89905 6 7.06515 6.06851 7.20216 6.20553L12 11.0034L16.7978 6.20553C16.9288 6.07458 17.0934 6.00759 17.2916 6.00456C17.4898 6.00152 17.6575 6.06851 17.7945 6.20553C17.9315 6.34254 18 6.50864 18 6.70384C18 6.89905 17.9315 7.06515 17.7945 7.20216L12.9966 12L17.7945 16.7978C17.9254 16.9288 17.9924 17.0934 17.9954 17.2916C17.9985 17.4898 17.9315 17.6575 17.7945 17.7945C17.6575 17.9315 17.4914 18 17.2962 18C17.101 18 16.9349 17.9315 16.7978 17.7945L12 12.9966Z"
        fill="current"
      />
    </g>
  </svg>
);
export default CloseIcon;
